<template>
  <va-card stripe="danger" title="Spots">
    <template slot="actions">
      <va-button color="danger" @click="createSpot" icon="fa fa-plus"/>
    </template>
    <SpotCreateModal @closemodal="closeSpot" @update="updateSpot" :location-id="locationId" :open-modal="openSpotModal"/>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
      <template v-slot:spotCount="props">
        {{props.rowData.identifiers.length}}
      </template>
      <template v-slot:actions="props">
        <va-button
          small
          outline
          color="info"
          icon="fa fa-eye"
          class="ma-0"
          @click="toSpots(props.rowData.spotClassificationId)"
        >
          {{ $t('events.viewSpots') }}
        </va-button>
        <va-button
          style="margin-left: 10px !important;"
          small
          outline
          color="danger"
          icon="fa fa-trash"
          class="ma-0"
          @click="showPromptModal(props.rowData.spotClassificationId)"
        >
          {{ $t('events.remove') }}
        </va-button>
      </template>
    </va-data-table>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('events.removeModalTitle')"
      :message="$t('events.removeModalMessage')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('events.removeModalNo') }}</va-button>
        <va-button type="submit" @click="removeClassification(spotClassificationIdInPrompt)" class="my-0">{{ $t('events.removeModalYes') }}</va-button>
      </div>
    </va-modal>
  </va-card>
</template>

<script>
import debounce from 'lodash/debounce'
import SpotCreateModal from '../modals/SpotCreateModal'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
export default {
  name: 'SpotLocationTable',
  components: { SpotCreateModal },
  mixins: [errorHandlerMixin],
  data () {
    return {
      spots: [].slice(),
      loading: false,
      term: null,
      mode: 0,
      openSpotModal: false,
      showRemoveModal: false,
      spotClassificationIdInPrompt: null,
    }
  },
  props: {
    lspots: Array,
    locationId: Number,
  },
  computed: {
    fields () {
      return [{
        name: 'name',
        title: 'name',
      }, {
        name: 'spotIdentifier',
        title: 'Identifier',
      }, {
        name: '__slot:spotCount',
        title: 'Spots',
      }, {
        name: '__slot:actions',
        title: 'actions',
      }]
    },
    modeOptions () {
      return [{
        value: 0,
        label: this.$t('dashboard.table.brief'),
      }]
    },
    filteredData () {
      return this.spots
    },
  },
  methods: {
    createSpot () {
      this.openSpotModal = true
    },
    closeSpot (state) {
      this.openSpotModal = state
    },
    updateSpot (spot) {
      this.spots.splice(this.spots.length, -1, spot[0])
    },
    showPromptModal (spotClassificationId) {
      this.spotClassificationIdInPrompt = spotClassificationId
      this.showRemoveModal = true
      console.log('spotClassificationId ' + spotClassificationId)
    },
    removeClassification (spotClassificationId) {
      this.loading = true
      this.$store.dispatch('deleteSpotClassification', spotClassificationId)
        .then(() => {
          this.removeThatClassification(spotClassificationId)
          this.showRemoveModal = false
        })
        .catch(error => {
          this.errorHandler(error.response)
          this.loading = false
          this.showRemoveModal = false
        })
    },
    removeThatClassification (spotClassificationId) {
      const idx = this.spots.findIndex(u => u.spotClassificationId === spotClassificationId)
      this.spots.splice(idx, 1)
      this.loading = false
    },
    getStatusColor (status) {
      if (status === 'paid') {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },
    async toSpots (classificationId) {
      await this.$router.push({
        name: 'spots',
        params: { classificationId: classificationId },
      })
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  mounted () {
    this.spots = this.lspots.slice()
  },
}
</script>

<style lang="scss">
</style>
